import * as R from 'core/helpers/remeda'
import { CaseCreationProcedure, DebtValidation } from 'core/types/types'

export const creationProcedureLabels = {
  automatedCollectionsDetection: 'Automated Collections',
  automatedOfacDetection: 'Compliance Guard',
  automatedBankruptcyDetection: 'Compliance Guard',
  automatedDeceasedDetection: 'Compliance Guard',
  automatedScraDetection: 'Compliance Guard',
  supercasePopulationCommit: 'Supercase',
} as const satisfies { [_ in NonNullable<CaseCreationProcedure>]?: string }

export const stateCodeLabels = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const

export const stateCodeOptions = R.pipe(
  stateCodeLabels,
  R.toPairs,
  R.map(([value, label]) => ({ value, label })),
)

const newYorkCityLabels = {
  newYorkCity: 'New York City',
  yonkers: 'Yonkers',
  other: 'Other',
} as const satisfies { [_ in NonNullable<DebtValidation['newYorkStateCity']>]: string }

export const newYorkCityOptions = R.pipe(
  newYorkCityLabels,
  R.toPairs,
  R.map(([value, label]) => ({ value, label })),
)
